// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2e536110","977":"4e22cef6"}[chunkId] + ".chunk.js";
};